const reviews = [
  {
    id: 1,
    name: "Aisha Rahman",
    review:
      "Events Glamour turned our wedding into something truly magical. Every detail was handled with care and elegance.",
  },
  {
    id: 2,
    name: "James Carter",
    review:
      "Our corporate launch looked premium from start to finish. The team was professional, creative, and incredibly reliable.",
  },
  {
    id: 3,
    name: "Fatima Al Maktoum",
    review:
      "The décor and lighting completely transformed our venue. Guests are still talking about how beautiful everything looked.",
  },
  {
    id: 4,
    name: "Priya Sharma",
    review:
      "From planning to execution, everything felt seamless. They understood our vision and made it even better.",
  },
  {
    id: 5,
    name: "Omar Hassan",
    review:
      "We hosted an anniversary dinner and it exceeded every expectation. Elegant setup, perfect flow, unforgettable night.",
  },
  {
    id: 6,
    name: "Sophia Bennett",
    review:
      "Their attention to detail is unmatched. The florals, furniture, and styling created a luxury atmosphere throughout.",
  },
  {
    id: 7,
    name: "Rahul Mehta",
    review:
      "Communication was clear and the team delivered exactly what they promised. Highly recommend for any special event.",
  },
  {
    id: 8,
    name: "Layla Ibrahim",
    review:
      "Our proposal setup was intimate and stunning. Events Glamour made a once-in-a-lifetime moment feel effortless.",
  },
  {
    id: 9,
    name: "Daniel Brooks",
    review:
      "They managed our full event production with style and precision. Lighting, sound, and décor were all on point.",
  },
  {
    id: 10,
    name: "Noura Saeed",
    review:
      "Working with Events Glamour was a pleasure. Beautiful design, smooth coordination, and a truly glamorous result.",
  },
];

export default reviews;
